import { mixins, tokens } from '@mindtickle/styles/lib';
import styled from 'styled-components';
import { navigationDefaultColors } from '../../data';

export const StyledNavFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 0;
  &:empty {
    padding: 0;
  }

  .nav-action-btn-copilot-wrapper {
    width: 63px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .nav-action-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: ${tokens.typography.FONT_SIZE_S};
    cursor: pointer;
    color: ${tokens.textTokens.COLOR_TEXT_WHITE};
    color: ${navigationDefaultColors.navCopilotIconColor};
    background-color: ${navigationDefaultColors.navCopilotBgColor};
  }

  .nav-container-action-btn-wrapper {
    width: 32px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    background-color: ${navigationDefaultColors.toggleBtnBgColor};

    &:hover {
      background-color: ${navigationDefaultColors.toggleBtnBgHoverColor};
    }
  }

  .toggle-icon-btn {
    font-size: 20px;
    color: ${navigationDefaultColors.toggleBtnIconColor};

    &:hover {
      color: ${navigationDefaultColors.toggleBtnIconHoverColor};
    }
  }

  &.collapsed-state {
    .nav-container-action-btn-wrapper,
    .nav-action-btn-copilot-wrapper {
      margin: 0 auto;
    }
  }

  &.expanded-state {
    .nav-container-action-btn-wrapper {
      margin: 0 16px;
    }
  }

  &.freshchat-berry-enabled {
    justify-content: space-between;
  }
`;

export const overlayStyle = {
  zIndex: mixins.zIndex.TOOLTIP,
};
